/* Menu functions */
(function( ) {
    'use strict'

    /* Toggle scrolled state */
    if ( document.querySelector('.menu-button-container') != null ) {
        document.querySelector('.menu-button-container').addEventListener( 'click', ( e ) => {
            e.preventDefault()
            document.querySelector( 'body' ).classList.toggle( 'is-open-menu' )

            /* Check for active / inactive */
            if ( this.classList.contains( 'active' ) ) {
                /* State is active */
                let clickedElem = this
                this.classList.add( 'closing' )
                document.querySelector( 'body' ).classList.remove( 'navigation-open' )
 
                /* Remove active after turning */
                setTimeout( () => { 
                    clickedElem.classList.remove( 'active' )
                }, 400 )
                setTimeout( () => { clickedElem.classList.remove( 'closing' ) }, 600 )
            } else {
                /* State is inactive */
                this.classList.add( 'active' )
                document.querySelector('body').classList.add( 'navigation-open' )
            }

            /* Return */
            return false
        })
    }
})( )
